import { render, staticRenderFns } from "./PrivilegeGrid.vue?vue&type=template&id=001777da&"
import script from "./PrivilegeGrid.vue?vue&type=script&lang=ts&"
export * from "./PrivilegeGrid.vue?vue&type=script&lang=ts&"
import style0 from "./PrivilegeGrid.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports